// The café's day, as the user means it: the local calendar date. toISOString()
// would roll over to the next day after 22:00 in Belgium, so never use it here.
export const localISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const todayISO = () => localISO(new Date());

export const daysAgoISO = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return localISO(d);
};

export const isToday = (iso) => iso === todayISO();
export const isYesterday = (iso) => iso === daysAgoISO(1);
